/* globals dataLayer, pageContext, currency, console */

var $cache = {},
    promoViews = [],
    productImpressions = [],
    productDetailImpression = [],
    checkoutData = null,
    purchaseData = null,
    removedProductData = null;

const eventMgr = require('_core_ext/eventMgr');
const Promise = require('promise');
const _throttle = require('lodash/function/throttle');
const util = require('_core_ext/util');

window.dataLayer = window.dataLayer || [];

function _initializeCache() {
    $cache.document = $(document);
    $cache.lists = $('.js-tiles-container, .js-products-container');
}

/**
 * @description Single method for pushing data
 * useful for debugging
 * @example console.info('dataLayer.push', data);
 *
 * @param data
 * @returns {Object} dataLayer
 */
function _pushToDataLayer(data) {
    window.dataLayer = window.dataLayer || [];
    return dataLayer.push(data);
}

function _sendEcommerceData() {
    var dataObject = {
        'ecommerce': {}
    };

    if (productDetailImpression.length) {
        // dataObject.ecommerce.detail = {};

        var items = productDetailImpression[0].length ? productDetailImpression[0] : productDetailImpression;
        var totalValue = 0;
        var masterProductID = $('#pdpMain').attr('data-master-product-id');

        // Add list property to each item
        for (var i = 0; i < items.length; i++) {
            var product = items[i];
           
            if (items.length > 1) {
                product.index = i + 1;
            } else {
                var savedIndex = localStorage.getItem('ga4_index_' + product.item_id) || (masterProductID ? localStorage.getItem('ga4_index_' + masterProductID) : '');
                if (savedIndex) {
                    product.index = parseInt(savedIndex, 10);
                }
            }
            
            var productPrice = product.price;
            var quantity = product.quantity || 1;
            totalValue += productPrice * quantity;

            var listItemId = localStorage.getItem('ga4_' + product.item_id) || (masterProductID ? localStorage.getItem('ga4_' + masterProductID) : '') || '';
            var listItemName = localStorage.getItem('ga4_name_' + product.item_id) || (masterProductID ? localStorage.getItem('ga4_name_' + masterProductID) : '') || '';

            if (!listItemId || !listItemName) {
                // Find deepeset item_category available
                // 1. Start with Level 1
                var lastCategory = product.item_category;
                var catIndex = 2;
                //  Check if item_category2 exists, then item_category3, etc.
                while (product['item_category' + catIndex]) {
                    lastCategory = product['item_category' + catIndex];
                    catIndex++;
                }
                
                if (!listItemId) {
                    listItemId = lastCategory;
                }
                if (!listItemName) {
                    listItemName = lastCategory;
                }
            }

            items[i].item_list_id = listItemId;
            items[i].item_list_name = listItemName;
        }
        totalValue = Number(Math.abs(totalValue).toFixed(2));

        dataObject.ecommerce.value = totalValue;
        dataObject.ecommerce.currency = currency;
        
        dataObject.ecommerce.items = items;
        dataObject.event = 'view_item';
    }

    if (checkoutData) {
        dataObject.ecommerce.checkout = checkoutData.ecommerce.checkout;
        if (!purchaseData) {
            dataObject.ecommerce.checkout.actionField = checkoutData.ecommerce.checkout.actionField;
        }
        dataObject.event = 'checkout';
        dataObject.pageType = 'checkout';
    }

    if (purchaseData) {
        dataObject.ecommerce.purchase = purchaseData.ecommerce.purchase;
        dataObject.ecommerce.purchase.actionField = purchaseData.actionField;
        dataObject.ecommerce.currencyCode = currency;
        dataObject.event = 'purchase';
    }

    if (removedProductData) {
        dataObject.ecommerce.remove = removedProductData.ecommerce.remove;
        dataObject.event = removedProductData.event;
    }
    
    if (Object.keys(dataObject.ecommerce).length) {
        _pushToDataLayer(dataObject);
    }
}

function _listPageIdentifier() {
    var pageType = pageContext.gtm.gtmPageData && pageContext.gtm.gtmPageData.pageType || pageContext.type;
    var result = '';
    switch (pageType) {
        case 'product list':
        case 'category landing':
            if (!result) {
                result = [pageType, pageContext.gtm.category].join(', ') + ' ';
            }
            break;
        default:
            result = pageType;
    }
    return result;
}

function _listPageNameIdentifier() {
    var pageType = pageContext.gtm.gtmPageData && pageContext.gtm.gtmPageData.pageType || pageContext.type;
    var result = '';
    switch (pageType) {
        case 'product list':
        case 'category landing':
            if (!result) {
                result = `${pageContext.algonomyData.categoryName} (${[pageType, pageContext.algonomyData.categoryName].join(', ')})`;
            }
            break;
        default:
            result = pageType;
    }
    return result;
}

function _processList($list, counter, listName, isTilesAppend) {
    var pageIdentifier = _listPageIdentifier();
    // var pageNameIdentifier = _listPageNameIdentifier();
    $list.find('.js-component-product-tile').each(function(index) {
        var $tile = $(this),
            tileData = $tile.data('gtm');
        if (tileData !== null && typeof tileData === 'object') {
            tileData.index = ++index + counter;
            tileData.item_list_name =_getProductListName($tile);
            tileData.item_list_id =  listName ? `${listName} (${pageIdentifier})` : _getProductList($tile);
            $tile.data('gtm', tileData);

            if (!isTilesAppend) {
                var $tileOnPage = $('#product-search-result-items').find('[data-product-id="' + $tile.data('productId') + '"]');
                if ($tileOnPage.length) {
                    $tileOnPage.data('gtm', tileData);
                }
            }
        }
    });
}

function _findPromoContent($container) {
    $container = $container || $(document); 
    const promos = $container.find('[data-asset-gtm]');

    promos.each((i, el) => {
        const $promo = $(el),
            $container = $promo.closest('.js-gtm-asset-container'),
            promoData = $promo.data('asset-gtm');

        // same asset can be rendered in different places but should be tracked separately,
        // so we will maintain collection of all of them, but mark visited and viewed with respective data-* attributes
        // to omit during checks
        if ($container.data('gtm-visited')) {
            return;
        }
        
        if (!$container.length) { 
            console.debug(`GTM: No .js-gtm-asset-container wrapper for asset "${promoData.item_id}", content will not be tracked!`);    // eslint-disable-line no-console
            return;
        }
        
        $container.data('gtm-visited', true);
        promoViews.push({
            data: promoData,
            $el: $container
        });
    });
}

function _trackVisiblePromos() {
    var track = [];
    
    for (let i = 0, len = promoViews.length; i <  len; i++) {
        const promoView = promoViews[i];
        if (promoView.$el.data('gtm-viewed')) {
            // skip already viewed elements
            continue;
        }
        
        if (util.isVisible(promoView.$el[0])) {
            promoView.$el.data('gtm-viewed', true);
            track.push(promoView.data);
        }
    }
    
    if (track.length > 0) {
        _pushToDataLayer({
            'event': 'view_promotion',
            'ecommerce': {

                'items': track
            }
        })
    }
}

function _insertGtmScript() {
    var gtmContainerID = SitePreferences.GTM_CONTAINER_ID || '';
    var gtmScript = document.createElement('script');
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
	new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
	j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
	'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
	}
	)(window,document,'script','dataLayer','${gtmContainerID}');`;
    document.head.appendChild(gtmScript);
}

var _throttledTrackVisiblePromos = _throttle(_trackVisiblePromos, 200);

function _initialRequests() {
    if (typeof pageContext === 'undefined' || typeof pageContext.gtm !== 'object') {
        return;
    }

    // 1. Push virtual_page_view first — page/user context must be in the dataLayer
    if (pageContext.gtm.gtmVirtualPageView) {
        _pushToDataLayer(_enrichData(pageContext.gtm, 'gtmVirtualPageView'));
    }

    // 2. Load GTM container (triggers the gtm.js event inside Tag Assistant /
    //    Google Analytics)
    _insertGtmScript();

    // 3. Push all remaining events.
    for (var key in pageContext.gtm) {
        if (key === 'gtmVirtualPageView') continue; // already pushed above

        if (pageContext.gtm[key].ecommerce) {
            if (pageContext.gtm[key].ecommerce.purchase) {
                purchaseData = pageContext.gtm[key];
                continue;
            }

            if (pageContext.gtm[key].ecommerce.checkout) {
                checkoutData = pageContext.gtm[key];
                var initialPageData = _enrichData(pageContext.gtm, key, true);
                _pushToDataLayer(initialPageData);
                continue;
            }

            if (pageContext.gtm[key].ecommerce.remove) {
                removedProductData = pageContext.gtm[key];
                continue;
            }
        }

        var enrichedGtmData = _enrichData(pageContext.gtm, key);
        _pushToDataLayer(enrichedGtmData);
    }

    // (gtm script already inserted above)

    _findPromoContent($(document));
    _throttledTrackVisiblePromos();

    $cache.lists.each(function() {
        var $list = $(this),
            counter = $list.find('.pagination').data('gtm-start') || 0;
        _processList($list, counter, $list.data('list-name'));
    });
    _proceedProductTilesImpressions();

    if (('gtmProductDetailView' in pageContext) && pageContext.gtmProductDetailView !== null
            && $cache.document.find('.product-detail') && $cache.document.find('.js-product-tile-wrapper')) {
        productDetailImpression.push(pageContext.gtmProductDetailView);
    }

    _sendEcommerceData();

    var $miniCartContent = $('.js-mini-cart-content');
    if ($miniCartContent.length) {
        var gtmData = $miniCartContent.data('gtm');
        if (gtmData) {
            _pushToDataLayer(gtmData);
        }
    }

    _pushToDataLayer({'event': 'pageDataReady'});

}

function _enrichData(gtm, key, createFromBlank) {
    var gtmData = createFromBlank ? {} : gtm[key];
    if ((key === 'gtmPageData' || createFromBlank) && gtm.gtmUserData) {
        if (gtm.gtmUserData.language) gtmData.language = gtm.gtmUserData.language;
        if (gtm.gtmUserData.country) gtmData.country = gtm.gtmUserData.country;
        if (gtm.gtmUserData.visitorType) gtmData.visitorType = gtm.gtmUserData.visitorType;
        if (gtm.gtmUserData.visitorId) gtmData.visitorId = gtm.gtmUserData.visitorId;
        gtmData.loyaltyPoints = gtm.gtmUserData.loyaltyPoints || 0;
        if (gtm.gtmUserData.crmNumber) gtmData.crmNumber = gtm.gtmUserData.crmNumber;
        if (gtm.gtmUserData.tier) gtmData.accountType = gtm.gtmUserData.tier;
        if (gtm.gtmUserData.lastLoginTime) gtmData.lastLoginTime = gtm.gtmUserData.lastLoginTime;
        if (gtm.gtmUserData.lastVisitTime) gtmData.lastVisitTime = gtm.gtmUserData.lastVisitTime;
        if (gtm.gtmUserData.loyaltyCustomer) gtmData.loyaltyCustomer = gtm.gtmUserData.loyaltyCustomer;
        if (gtm.gtmUserData.employee) gtmData.employee = gtm.gtmUserData.employee;
    }
    if ((key === 'gtmUserData' || key === 'gtmVirtualPageView' || createFromBlank) && gtm.gtmPageData) {
        if (gtm.gtmPageData.pageType) gtmData.pageType = gtm.gtmPageData.pageType;
        if (gtm.gtmPageData.department) gtmData.department = gtm.gtmPageData.department;
    }

    if (key === 'gtmVirtualPageView') {
        if (gtmData.tier && gtmData.visitorId) {
            gtmData.accountType = gtmData.tier;

        } else if (!gtmData.visitorId) {
            gtmData.accountType = 'guest';
        }
        delete gtmData.tier; // Remove source property after mapping to clean up
    }

    return gtmData;
}

function _productRequest() {
    var productData = this.productData,
        event = this.event,
        action = this.action,
        actionField = this.actionField,
        eventCallback = this.eventCallback,
        currencyCode = this.currencyCode,
        value = this.value,
        productRequest = {};

    // Add list property to each item if available
    for (let i = 0; i < productData.length; i++) {
        var product = productData[i];
        if (this.list_item_name) {
            product.item_list_name = this.list_item_name;
        }
        if (this.list_item_id) {
            product.item_list_id = this.list_item_id;
        }
        if (this.index) {
            product.index = parseInt(this.index, 10);
        }

        if (event === 'add_to_cart') {
            delete productData[i].dimension19;
            delete productData[i].dimension20;
        }

        var listItemId = product.item_list_id;
        var listItemName = product.item_list_name;

        if (!listItemId || !listItemName) {
            // Find deepeset item_category available
            var lastCategory = product.item_category;
            var catIndex = 2;
            while (product['item_category' + catIndex]) {
                lastCategory = product['item_category' + catIndex];
                catIndex++;
            }
            
            if (!listItemId) {
                listItemId = lastCategory;
            }
            if (!listItemName) {
                listItemName = lastCategory;
            }
        }
        product.item_list_id = listItemId;
        product.item_list_name = listItemName;
    }

    productRequest.event = event;
    productRequest.ecommerce = {};
    if (currencyCode) {
        productRequest.ecommerce.currency = currencyCode;
    }

    productRequest.ecommerce.value = value;


    productRequest.ecommerce.items = productData;

    if (typeof eventCallback === 'function') {
        productRequest.eventCallback = eventCallback;
    }

    return _pushToDataLayer(productRequest);
}


function _addToCartRequest(productsData, value) {
    var listItemId = '';
    var listItemName = '';
    var index = null;
    var productID = productsData[0].item_id;
    // check if quickview or reqular pdp
    if ($('#pdpMain[data-master-product-id="' + productID + '"]').closest('#QuickViewDialog').length) {
        var productTile = $('.js-component-product-tile[data-master-product-id="' + productID + '"]')[0];
        listItemId = _getProductList($(productTile));
        listItemName = _getProductListName($(productTile));
        var tileData = $(productTile).data('gtm');
        if (tileData && tileData.index) {
            index = tileData.index;
        }
    } else {
        listItemId = localStorage.getItem('ga4_' + productID || '');
        listItemName = localStorage.getItem('ga4_name_' + productID || '');
        index = localStorage.getItem('ga4_index_' + productID || '');
        var setMasterProductID = $('#pdpMain').attr('data-master-product-id');
        if (setMasterProductID && setMasterProductID !== productID) {
            if (!listItemId) {
                listItemId = localStorage.getItem('ga4_' + setMasterProductID) || '';
            }
            if (!listItemName) {
                listItemName = localStorage.getItem('ga4_name_' + setMasterProductID) || '';
            }
        }
    }

    return _productRequest.call({
        'productData': productsData,
        'event': 'add_to_cart',
        'action': 'add',
        'currencyCode': currency,
        'value': value,
        'list_item_id': listItemId,
        'list_item_name': listItemName,
        'index': index
    });
}

function _removeFromCartRequest(productsData, value) {
    return _productRequest.call({
        'productData': productsData,
        'event': 'remove_from_cart',
        'action': 'remove',
        'currencyCode': currency,
        'value': value
    });
}

function _onQuickViewShow(sender) {
    var productData = $(sender).closest('.js-component-product-tile').data('gtm');

    // Use the list from product impression list attribute according to documentation
    var list = productData && productData.list;

    _productRequest.call({
        productData: [productData],
        event: 'select_item',
        action: 'click',
        list: list
    });

    var qvProductData = {
        productData: [productData],
        event: 'productView',
        action: 'detail',
        list: list
    };
    _productRequest.call(qvProductData);
}

function _proceedProductTilesImpressions() {
    var productTiles = $cache.document.find('.js-component-product-tile:not([data-gtm-viewed=true])');

    productTiles.filter(function (i, el) {
        // filter out tiles in carousels
        return !$(el).closest('.js-product-carousel, .js-slick-product-carousel').length;
    }).each(function (i, el) {
        var $productTile = $(el);
        // send all PLP tiles once on page, but mark them as viewed so they don't sent again
        $productTile.attr('data-gtm-viewed', true);
        productImpressions.push($productTile.data('gtm'));
    });
    _sendProductImpressions();
}

// as carousels have cloned elements - need to have specific search to make sure info is not doubled
function _proceedCarouselProductTilesImpressions($carousel) {
    var tiles = $carousel.find('.js-component-product-tile:not([data-gtm-viewed=true])');
    tiles.each(function (i, el) {
        var $productTile = $(el);

        // mark all copies as viewed not to be selected for push by any other selector
        var isVievedCopyPresent = $carousel.find('[data-product-id="' + $productTile.data('product-id') + '"][data-gtm-viewed=true]').length;
        if (isVievedCopyPresent) {
            $carousel.find('[data-product-id="' + $productTile.data('product-id') + '"]').attr('data-gtm-viewed', true);
        }

        if (!isVievedCopyPresent && util.isVisible($productTile[0])) {
            $carousel.find('[data-product-id="' + $productTile.data('product-id') + '"]').attr('data-gtm-viewed', true);
            productImpressions.push($productTile.data('gtm'));
        }
    })
    _sendProductImpressions();
}

/**
 * send vieved products
 * if user see more that chunk maximum - send full chunk and the rest with another event
 */
function _sendProductImpressions() {
    // send products in chunks by 30
    var maxProducts = SitePreferences.PAYLOAD_MAXSIZE || 30;
    while (productImpressions.length) {
        var productImpressionsChunk = productImpressions.splice(0, maxProducts); 

        if (productImpressionsChunk.length) {
            // Calculate total value
            var totalValue = 0;
            
            // Copy chunk to not mutate original objects and remove dimension15
            var itemsForEvent = [];
            
            for (let i = 0; i < productImpressionsChunk.length; i++) {
                var item = productImpressionsChunk[i];
                var itemPrice = item.price;
                totalValue += itemPrice;
                
                // Create shallow copy and remove dimension15 for view_item_list event.
                var itemCopy = $.extend({}, item);
                if ('dimension15' in itemCopy) {
                    delete itemCopy.dimension15;
                }
                itemsForEvent.push(itemCopy);
            }
            totalValue = Number(Math.abs(totalValue).toFixed(2));

            _pushToDataLayer({
                'ecommerce': {
                    'currency': currency,
                    'value': totalValue,
                    'items': itemsForEvent
                },
                'event': 'view_item_list'
            });
        }
    }
}

function _saveProductList($tile) {
    var productData = $tile.data('gtm');
    var listWithPage = _getProductList($tile);

    localStorage.setItem('ga4_' + productData.item_id, listWithPage); // set data to localStorage because sessionStorage is empty in new tabs so can't save data
    if (productData.index) {
        localStorage.setItem('ga4_index_' + productData.item_id, productData.index);
    }
}

function _saveProductListName($tile) {
    var productData = $tile.data('gtm');
    var listName = _getProductListName();
    localStorage.setItem('ga4_name_' + productData.item_id, listName); // set data to localStorage because sessionStorage is empty in new tabs so can't save data
}

function _getProductList($tile) {
    var pageIdentifier = _listPageIdentifier();
    // get list name from parent container
    var list = $tile.closest('.grid-tile, .js-tiles-container, .js-products-container').data('gtm')
        || $tile.closest('[data-gtm-list]').data('gtm-list')
        || $tile.closest('[data-list-name]').data('list-name');
    if (!list) {
        return pageIdentifier;
    }
    return `${list} (${pageIdentifier})`;
}

function _getProductListName() {
    var pageIdentifier = _listPageNameIdentifier();
    return `${pageIdentifier}`;

}

function _initializeEvents() {
    eventMgr.on('search.productTilesAppend', function(data, itemsCount, listName) {
        _processList(data, itemsCount, listName, true);
        _proceedProductTilesImpressions();
    });
    
    eventMgr.on('page.newView', function(data) {
        _pushToDataLayer({
            'event': 'pageView',
            'pageUrl': data.url,
            'pageTitle': data.title
        });
        $('.js-products-container').each(function() {
            var $container = $(this);
            _processList($container, 0, $container.data('list-name'));
        });
        _sendEcommerceData();
    });

    eventMgr.on('search.productListUpdated', function(data, itemsCount, listName) {
        //specific for productListUpdated
        itemsCount = 0;

        // Check for refinement update
        var $refinementInput = data.find('[data-gtmrefinement]');
        if ($refinementInput.length) {
            try {
                var refinementData = JSON.parse($refinementInput.attr('data-gtmrefinement'));
                if (refinementData) {
                    _pushToDataLayer(refinementData);
                }
            } catch (e) {
                console.error('GTM: Error parsing refinement data', e);
            }
        }

        _processList(data, itemsCount, listName);
        _proceedProductTilesImpressions();
    });
    
    $cache.document.on('recommendations.initPredictiveRecommendations', (event, slotID) => {
        const $recommSlot = $(`[data-slot-id="${slotID}"]`);
        _processList($recommSlot, 0, $recommSlot.data('gtm') || $recommSlot.closest('[data-gtm-list]').data('gtm-list'));
        _proceedCarouselProductTilesImpressions($recommSlot);
    });
    
    eventMgr.on('product.quickViewShow', _onQuickViewShow);
    eventMgr.on('quickViewGlobal.select_item', _onQuickViewShow);
    eventMgr.registerAction('gtm.addBonusProducts', function(bonusProductsGTMData) {
        return Promise.resolve(_addToCartRequest(bonusProductsGTMData));
    });
    
    $cache.document.on('click', '.js-component-product-tile a.js-product-url', function(event) {
        event.preventDefault();
        var $this = $(this),
            productData = $this.closest('.js-component-product-tile').data('gtm') || {},
            url = $this.attr('href'),
            navStarted = false; // flag to prevent double page requests
        var productPrice = productData.price;
        productPrice = Number(Math.abs(productPrice).toFixed(2));
        _saveProductList($this.closest('.js-component-product-tile'));
        _saveProductListName($this.closest('.js-component-product-tile'));
        _productRequest.call({
            productData: [productData],
            event: 'select_item',
            action: 'click',
            value: productPrice,
            currencyCode: currency,
            list: productData && productData.list || '',
            eventCallback: function() {
                if (navStarted) {
                    return;
                }
                navStarted = true;
                document.location = url;
            }
        });

        setTimeout(function () {
            if (navStarted) {
                return;
            }
            navStarted = true;
            document.location = url;
        }, 500);
    });

    $cache.document.on('click', '.add-to-cart, .js-add-to-cart', function() {
        var productsData = [];
        var $form = $(this).closest('form'),
            productData = $form.data('gtm');
        // if there is error in form, don't send add to cart event
        if ($form.find('.js-collapse-out-click').hasClass('error')) {
            return;
        }

        if (productData) {
            productData.quantity = + $form.find('.js-quantity, input[name="Quantity"]').val();
            productsData.push(productData);
        }
        var productPrice = productData.price;
        var value = Number(Math.abs(productPrice * productData.quantity).toFixed(2));
    
        _addToCartRequest(productsData, value);
    });

    // Track remove_from_cart event when user clicks delete button on cart page
    $cache.document.on('click', '[data-event="remove_from_cart"]', function() {
        var productsData = [];
        var $lineItem = $(this).closest('.line-item-wrapper');
        var $hiddenInput = $lineItem.find('.js-remove-from-cart-data');

        if ($hiddenInput.length) {
            try {
                var productDataStr = $hiddenInput.attr('data-removeCartData');
                var productData = JSON.parse(productDataStr);

                // Transform to GA4 format
                var gtmProductData = productData;
                gtmProductData.index = $lineItem.index() + 1;
                productsData.push(gtmProductData);
                var productPrice = productData.price;
                var value = Number(Math.abs(productPrice * productData.quantity).toFixed(2));
                _removeFromCartRequest(productsData, value);
            } catch (error) {
                console.error('GTM: Error parsing remove from cart data', error);
            }
        }
    });

    // Track remove_from_cart event when user updadted quantity on cart page
    $cache.document.on('change', '.js-cartitem-quantity-wrapper .js-quantity', function() {
        var $quantityInput = $(this);
        var $lineItem = $quantityInput.closest('.line-item-wrapper');
        var $hiddenInput = $lineItem.find('.js-remove-from-cart-data');
        var newQuantity = parseInt($quantityInput.val(), 10) || 0;

        if ($hiddenInput.length) {
            try {
                var productDataStr = $hiddenInput.attr('data-removeCartData');
                var productData = JSON.parse(productDataStr);
                var previousQuantity = parseInt(productData.quantity, 10);

                // Update the quantity in the hidden input
                productData.quantity = newQuantity;
                $hiddenInput.attr('data-removeCartData', JSON.stringify(productData));

                // Only track GTM event if quantity decreased (user removed items)
                if (newQuantity < previousQuantity) {
                    var quantityRemoved = previousQuantity - newQuantity;
                    var productsData = [];

                    // Create a copy for the removed quantity event
                    var removedProductData = jQuery.extend({}, productData);
                    removedProductData.quantity = quantityRemoved;
                    removedProductData.index = $lineItem.index() + 1;

                    productsData.push(removedProductData);
                    var productPrice = removedProductData.price;
                    var value = Number(Math.abs(productPrice * quantityRemoved).toFixed(2));
                    _removeFromCartRequest(productsData, value);
                }
            } catch (error) {
                console.error('GTM: Error tracking quantity change', error);
            }
        }
    });

    
    $cache.document.on('click', '.add-all-to-cart', function() {
        var productsData = [];
        var forms = $('.product-add-to-cart').find('form');
        var totalValue = 0;
        var listItemId = '';
        var listItemName = '';
        var productID = '';
        var masterProductID = $('#pdpMain').attr('data-master-product-id');

        $(forms).each(function() {
            var $form = $(this);
            if ($form.data('gtm')) {
                var productData = $form.data('gtm');
                productData.quantity = +$form.find('.js-quantity, input[name="Quantity"]').val();
                if (productData.quantity > 0) {
                    productsData.push(productData);
                    var productPrice = productData.price;
                    totalValue += productPrice * productData.quantity;
                    totalValue = Number(Math.abs(totalValue).toFixed(2));
                }
                productID = productData.item_id;
            }
            listItemId = localStorage.getItem('ga4_' + productID || '') || localStorage.getItem('ga4_' + masterProductID || '');
            listItemName = localStorage.getItem('ga4_name_' + productID || '') || localStorage.getItem('ga4_name_' + masterProductID || '');
        });

        _productRequest.call({
            'productData': productsData,
            'event': 'add_to_cart',
            'action': 'add',
            'currencyCode': currency,
            'value': totalValue,
            'list': productsData.length > 0 ? productsData[0].list : '',
            'list_item_id': listItemId || '',
            'list_item_name': listItemName || ''
        });
    });


    // Handle wishlist clicks via custom event triggered from AddToWishlist.js
    $cache.document.on('gtm:wishlistClick', function(event, $el) {
        var $this = $($el);
        var productData = {};

        //Try finding data in standard wrappers (PLP and PDP pages)
        var $dataInput = $this.closest('.js-wishlist-wrapper, .whishlist_instore-actions, .product-actions')
                              .find('.js-gtm-wishlist-data, .js-wishlist-product-data');

        //Fallback: Check direct siblings (common in cart/checkout templates)
        if (!$dataInput.length) {
            $dataInput = $this.siblings('.js-gtm-wishlist-data, .js-wishlist-product-data');
        }

        if ($dataInput.length) {
            // Get data from either attribute name
            var dataStr = $dataInput.attr('data-gtmwishlist') || $dataInput.attr('data-product-gtm');
            if (dataStr) {
                try {
                    var parsedData = JSON.parse(dataStr);
                    if (parsedData) {
                        productData = parsedData;
                    }
                } catch (e) {
                    console.error('GTM: Error parsing wishlist product data', e);
                }
            }
        }
        if (productData) {
            var productPrice = productData.price;
            productPrice = Number(Math.abs(productPrice).toFixed(2));

            var listItemId = localStorage.getItem('ga4_' + productData.item_id || '');
            var listItemName = localStorage.getItem('ga4_name_' + productData.item_id || '');
            var index = localStorage.getItem('ga4_index_' + productData.item_id || '');

            // Try to get index from parent tile if available (PLP context)
            var $productTile = $this.closest('.js-component-product-tile');
            if ($productTile.length) {
                var tileData = $productTile.data('gtm');
                if (tileData) {
                    if (tileData.index) {
                        index = tileData.index;
                    }
                    if (tileData.list_item_id) {
                        listItemId = tileData.list_item_id;
                    }
                    if (tileData.list_item_name) {
                        listItemName = tileData.list_item_name;
                    }
                }
            } else {
                // Try to get index based on line item (Cart context)
                var $cartLineItem = $this.closest('.js-component-cart-product-line-item');
                if ($cartLineItem.length) {
                    var $cartContainer = $this.closest('.line-items-body, .cart-items-form');
                    if ($cartContainer.length) {
                         var $items = $cartContainer.find('.js-component-cart-product-line-item');
                         var idx = $items.index($cartLineItem);
                         if (idx > -1) {
                             index = idx + 1;
                         }
                    }
                }
            }

            _productRequest.call({
                'productData': [productData],
                'event': 'add_to_wishlist',
                'action': 'wishlist',
                'value': productPrice,
                'currencyCode': currency,
                'list_item_id': listItemId,
                'list_item_name': listItemName,
                'index': index || 1
            });
        }
    });

    eventMgr.on('productPage.BuyWithApplePay.blocked', function(apBtn) {
        var productsData = [];
        var $form = $(apBtn).closest('form'),
            productData = $form.data('gtm');
        if (productData) {
            productData.quantity = 1;
            productData.price = parseFloat($form.find('.js-input-giftprice').val() || 0) || productData.price;
            productsData.push(productData);
        }

        _productRequest.call({
            'productData': productsData,
            'event': 'BuyWithApplePay.blocked',
            'action': 'click',
            'currencyCode': currency,
            'list': productsData.length > 0 ? productsData[0].list : ''
        });
    });

    eventMgr.on('productPage.BuyWithApplePay', function(apBtn) {
        var productsData = [];
        var $form = $(apBtn).closest('form'),
            productData = $form.data('gtm');
        if (productData) {
            productData.quantity = 1;
            productData.price = parseFloat($form.find('.js-input-giftprice').val() || 0) || productData.price;
            productsData.push(productData);
        }

        _productRequest.call({
            'productData': productsData,
            'event': 'BuyWithApplePay',
            'action': 'add',
            'currencyCode': currency,
            'list': productsData.length > 0 ? productsData[0].list : ''
        });
    });

    $cache.document.on('click', '[data-gtmpromotions] ~ * a', function(event) {
        var $this = $(this);

        // Links inside [data-asset-name] wrappers are nested content asset includes
        // (rendered by contentassetinclude.isml) — skip GTM tracking entirely.
        if ($this.closest('[data-asset-name]').length) {
            return;
        }

        var $target = $this.closest('.js-gtm-asset-container').find('[data-asset-gtm]');

        if ($target.length) {
            var contentData = $target.data('asset-gtm'),
                href = $this.attr('href'),
                opensInNewTab = $this.attr('target') === '_blank',
                navStarted = false; // flag to prevent double page requests
            _pushToDataLayer({
                'event': 'select_promotion',
                'ecommerce': {
                    'items': [contentData]
                },
                'eventCallback': function() {
                    if (opensInNewTab || navStarted) {
                        return;
                    }
                    navStarted = true;
                    document.location = href;
                }
            });
            if (!opensInNewTab) {
                event.preventDefault();
                //Fallback when for some reason GTM eventCallback doesn't called
                setTimeout(function () {
                    if (navStarted) {
                        return;
                    }
                    navStarted = true;
                    document.location = href;
                }, 500);
            }
        }
    });

    // Track navigation menu clicks on all menu levels (1, 2, 3)
    $cache.document.on('click', '.js-menu-item-wrapper, .level-3 li', function(event) {
        event.stopPropagation();

        var $container = $(this);
        // Use .children() to avoid matching nested navigation inputs from child menu items
        var $navigationInput = $container.children('[data-gtmnavigation]');

        if ($navigationInput.length) {

            var navigationDataStr = $navigationInput.attr('data-gtmnavigation');
            if (navigationDataStr) {
                var navigationData = JSON.parse(navigationDataStr);
                navigationData.type = window.innerWidth >= 768 ? 'menu_bar_navigation' : 'side_bar_navigation';

                var navigationEvent = Object.assign({ 'event': 'Navigation' }, navigationData, {
                    'ecommerce': undefined,
                    'cart_data': undefined
                });
                window.dataLayer.push(navigationEvent);
            }
        }
    });

    if ('gtmNextStepData' in pageContext && pageContext.gtmNextStepData) {
        if (pageContext.checkoutPage === 'payment') {
            $cache.document.on('click', 'form[class*="checkout"] [type="submit"], [name="dwfrm_cart_checkoutCart"], [name="dwfrm_accountvalidator_submit"]', function() {
                _pushToDataLayer(pageContext.gtmNextStepData);
            });
        }
        $cache.document.on('click', '.js-applepay-cart', function() {
            _pushToDataLayer(pageContext.gtmNextStepData);
        });
    }

    $cache.document.on('click', '.js-minicart-submit', function() {
        _pushToDataLayer($(this).data('checkout-gtm'));
    });

    // Track promoView.promotions and products in carousels upon actual content visibility
    var _throttledCarouselImpressions = _throttle(_proceedCarouselProductTilesImpressions, 200);
    $(window).on('scroll resize', function () {
        _throttledTrackVisiblePromos();
        _throttledCarouselImpressions($('.js-product-carousel, .js-slick-product-carousel'));
    });
    
    function promoObserverCb(mutations) {
        for (let i = 0; i < mutations.length; i++) {
            if (mutations[i].type === 'childList' && mutations[i].addedNodes.length > 0) {
                _findPromoContent($(mutations[i].target));
            }
        }
        _throttledTrackVisiblePromos();
    } 
    if (window.MutationObserver) {
        new MutationObserver(promoObserverCb).observe(document.body, {
            childList: true, 
            subtree: true, 
            attributes: true
        });
    } else {
        setInterval(() => {
            _findPromoContent($cache.document);
            _throttledTrackVisiblePromos();
        }, 1000);
    }

    // send products that became visible
    $(document).on('afterChange', '.js-slick-product-carousel', function (e) {
        _proceedCarouselProductTilesImpressions($(e.target));
    })

    // remove item from localStorage (used for actionField) on tab close
    $(window).on('beforeunload', function() {
        if (pageContext && pageContext.gtmProductDetailView) {
            var key = 'ga4_' + pageContext.gtmProductDetailView.id || '';
            var indexKey = 'ga4_index_' + pageContext.gtmProductDetailView.id || '';
            localStorage.removeItem(key);
            localStorage.removeItem(indexKey);
        }
    });
}

module.exports = {
    init: function () {
        if (!SitePreferences.GTM_ENABLED) {
            return;
        }
        
        // Delay analytics initialization after all other components.
        // This needed to for carousels initialized and so initially visible slide (only) tracked on page load
        eventMgr.execute('components.initialized').then(() => {
            _initializeCache();
            _initialRequests();
            _initializeEvents();
        });
    }
};
